import dayjs from 'dayjs';
import i18n from '../ui/i18n';

const customParseFormat = require('dayjs/plugin/customParseFormat');
const updateLocale = require('dayjs/plugin/updateLocale');

const localeBr = require('dayjs/locale/pt-br');
const localeCl = require('dayjs/locale/es-us');
const localePe = require('dayjs/locale/es-us');

const countryLocale = {
  br: localeBr,
  cl: localeCl,
  pe: localePe
}[i18n.locale];
dayjs.locale(countryLocale);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);

const capitalize = word => (typeof word !== 'string' ? '' : word.charAt(0).toUpperCase() + word.slice(1));
dayjs.updateLocale(countryLocale.name, { months: countryLocale.months.map(month => capitalize(month)) });

export const dateToFormatedString = (date, formatStr = 'DD/MM/YYYY HH:mm:ss', inputFormat = '') => {
  return inputFormat ? dayjs(date, inputFormat).format(formatStr) : dayjs(date).format(formatStr);
};

export const dateToClientFormat = date => {
  const dayFormat = 'dddd D';
  const monthFormat = 'MMMM';
  const yearFormat = 'YYYY';
  const day = dateToFormatedString(date, dayFormat);
  const month = dateToFormatedString(date, monthFormat);
  const year = dateToFormatedString(date, yearFormat);
  return `${day[0].toUpperCase()}${day.slice(1)} de ${month.toLowerCase()} del ${year.toLowerCase()}`;
};

export const now = (formatStr = 'DD/MM/YYYY HH:mm:ss') => dateToFormatedString(undefined, formatStr);
export const getDaysDifferenceBetweenDays = (dateBefore, dateAfter) => {
  return dayjs(dateAfter).diff(dayjs(dateBefore), 'days');
};

export const getMonthsDifferenceBetweenDates = (dateBefore, dateAfter) => {
  return dayjs(dateAfter).diff(dayjs(dateBefore), 'months');
};

export const dateAdd = (date, value, unit) => {
  return dayjs(date).add(value, unit);
};

export const dateSubtract = (date, value, unit) => dayjs(date).subtract(value, unit);

export const setDateOfMonth = (date, day) => dayjs(date).date(day);

export const daysInMonth = date => dayjs(date).daysInMonth();
